"use server";

import { createClient } from "@supabase/supabase-js";

const SITE_URL = process.env.NEXT_PUBLIC_APP_URL ?? process.env.NEXT_PUBLIC_SITE_URL ?? "https://atendia.dev.bmore.app";

export async function requestPasswordReset(formData: FormData): Promise<{ ok: boolean }> {
  const email = (formData.get("email") as string | null)?.trim();

  if (!email) return { ok: false };

  // Use a plain supabase-js client (NOT @supabase/ssr) so that resetPasswordForEmail
  // uses OTP/implicit flow instead of PKCE. This generates a standard token_hash
  // (no pkce_ prefix) that is verifiable from any browser or device — not just the
  // one that initiated the request.
  const supabase = createClient(
    process.env.NEXT_PUBLIC_SUPABASE_URL!,
    process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!,
    { auth: { autoRefreshToken: false, persistSession: false } }
  );

  // Anti-enumeration: always return ok regardless of whether the email exists
  await supabase.auth.resetPasswordForEmail(email, {
    redirectTo: `${SITE_URL}/auth/callback?type=recovery`,
  });

  return { ok: true };
}
